import { getSelectedVariants } from '../reducers';

export default (state, { name }) => getSelectedVariants(state)[name];
